import type { AppRouteModule } from '/@/router/types';

import { LAYOUT } from '/@/router/constant';

const customerPool: AppRouteModule = {
  path: '/pool',
  name: 'Pool',
  component: LAYOUT,
  redirect: '/pool/index',
  meta: {
    icon: 'clarity:resource-pool-solid-badged',
    title: '客户公海',
    hideChildrenInMenu: true,
    auth: 'customerpool',
    orderNo: 40,
  },
  children: [
    {
      path: 'index',
      name: 'PoolIndex',
      component: () => import('/@/views/admin/seas/index.vue'),
      meta: {
        title: '客户公海列表',
        hideMenu: true,
        ignoreKeepAlive: false,
        setting: {
          types: 'crm_customer',
          module: 'crm',
          controller: 'customer',
          action: 'pool',
        },
        auth: 'customerpool.pool',
      },
    },
    {
      path: 'detail/:id',
      name: 'CustomerPoolDetail',
      component: () => import('/@/views/admin/customer/CustomerDetail.vue'),
      meta: {
        title: '客户公海详情',
        hideMenu: true,
        currentActiveMenu: '/pool/index',
        ignoreKeepAlive: true,
        setting: {
          action: 'read',
          controller: 'customer',
          module: 'crm',
          types: 'crm_customer',
        },
        auth: 'customer.read',
      },
    },
  ],
};

export default customerPool;
